import { derinApiClient } from "./setup";
import {
  DerinUser,
  DerinApiResponse,
  CreateUserRequest,
  UpdateUserRequest,
} from "./interface";

export const getUsers = async (): Promise<DerinUser[]> => {
  const response = await derinApiClient().get<DerinApiResponse<DerinUser[]>>("/user");
  return response.data.data;
};

/** Exact email match (case-insensitive); rejects with a 404 when nobody has it. */
export const searchUserByEmail = async (email: string): Promise<DerinUser> => {
  const response = await derinApiClient().get<DerinApiResponse<DerinUser>>("/user/search", {
    params: { email },
  });
  return response.data.data;
};

export const getUserById = async (id: string): Promise<DerinUser> => {
  const response = await derinApiClient().get<DerinApiResponse<DerinUser>>(`/user/${id}`);
  return response.data.data;
};

export const createUser = async (data: CreateUserRequest): Promise<DerinUser> => {
  const response = await derinApiClient().post<DerinApiResponse<DerinUser>>("/user", data);
  return response.data.data;
};

export const updateUser = async (id: string, data: UpdateUserRequest): Promise<DerinUser> => {
  const response = await derinApiClient().patch<DerinApiResponse<DerinUser>>(`/user/${id}`, data);
  return response.data.data;
};

/**
 * Emails the activation link again to someone who hasn't activated yet. The API
 * issues a new code, so earlier invitation links stop working.
 */
export const resendInvite = async (id: string): Promise<{ email: string }> => {
  const response = await derinApiClient().post<DerinApiResponse<{ email: string }>>(
    `/user/${id}/resend-invite`
  );
  return response.data.data;
};

export const deleteUser = async (id: string): Promise<void> => {
  await derinApiClient().delete(`/user/${id}`);
};
